/** @format */

import styled from 'styled-components';

export const TooltipContainer = styled.div`
  margin-left: 8px;
  position: relative;
  display: inline-flex;
  align-items: center;
  z-index: 200;
  cursor: pointer;
`;

export const TooltipContent = styled.div`
  visibility: hidden;
  position: absolute;
  opacity: 0;
`;

export const PortaledTooltipContent = styled.div`
  position: fixed;
  background-color: white;
  color: #101828;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  z-index: 1000;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border: 0;
  min-width: 13.75rem;
  max-width: 90vw;
  white-space: normal;

  @media (max-width: 500px) {
    white-space: normal;
    transform: translateX(-50%);
    width: 240px;
  }

  &:after,
  &:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
  }

  &:after {
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: white transparent transparent transparent;
  }

  &:before {
    margin-left: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: #e5e7eb transparent transparent transparent;
    z-index: -1;
  }
`;
